module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens22-51bb4004e5dbefb75c38372f6407b426.jpg";